import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["selected"]
const _hoisted_8 = ["selected"]
const _hoisted_9 = ["selected"]
const _hoisted_10 = ["selected"]
const _hoisted_11 = ["selected"]
const _hoisted_12 = ["selected"]
const _hoisted_13 = { class: "card-toolbar" }
const _hoisted_14 = {
  type: "button",
  class: "btn btn-primary"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_16 = { class: "card-body pt-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle fa-fw" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pen fa-fw" }, null, -1)
const _hoisted_20 = {
  href: "#",
  class: "btn btn-sm btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_21 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_22 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-auto py-4",
  "data-kt-menu": "true"
}
const _hoisted_23 = { class: "menu-item px-3" }
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "menu-item px-3" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: _ctx.I18nUtils.translate('sea.pages.branches.searchHint')
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.name],
              [_directive_debounce, _ctx.getData, "500ms"]
            ]),
            _createElementVNode("select", {
              class: "form-select form-select-solid w-auto ms-5",
              "aria-label": "Select Branch Open Status",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onIsOpenChange($event)))
            }, [
              _createElementVNode("option", {
                value: "",
                selected: _ctx.isOpen === null
              }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.selectTextIsOpenAll")), 9, _hoisted_7),
              _createElementVNode("option", {
                value: "true",
                selected: _ctx.isOpen === true
              }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.selectTextIsOpenOpen")), 9, _hoisted_8),
              _createElementVNode("option", {
                value: "false",
                selected: _ctx.isOpen === false
              }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.selectTextIsOpenClosed")), 9, _hoisted_9)
            ], 32),
            _createElementVNode("select", {
              class: "form-select form-select-solid w-auto ms-5",
              "aria-label": "Select Branch Enabled Status",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onIsEnabledChange($event)))
            }, [
              _createElementVNode("option", {
                value: "",
                selected: _ctx.isEnabled === null
              }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.selectTextIsEnabledAll")), 9, _hoisted_10),
              _createElementVNode("option", {
                value: "true",
                selected: _ctx.isEnabled === true
              }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.branches.selectTextIsEnabledEnabled"
                )), 9, _hoisted_11),
              _createElementVNode("option", {
                value: "false",
                selected: _ctx.isEnabled === false
              }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.branches.selectTextIsEnabledDisabled"
                )), 9, _hoisted_12)
            ], 32)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", _hoisted_14, [
            _createElementVNode("span", null, [
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.buttonAddBranch")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_Datatable, {
          loading: _ctx.loading,
          "table-headers": _ctx.tableHeaders,
          data: _ctx.branchesRef,
          total: _ctx.totalRef,
          "page-number": _ctx.pageNumberRef,
          "page-size": _ctx.pageSizeRef,
          onPageSizeChange: _ctx.updatePageSize,
          onPageNumberChange: _ctx.updatePageNumber,
          onSort: _ctx.sortBranches
        }, {
          "cell-id": _withCtx(({ row: branch }) => [
            _createElementVNode("strong", null, _toDisplayString(branch.id), 1)
          ]),
          "cell-name": _withCtx(({ row: branch }) => [
            _createElementVNode("strong", null, _toDisplayString(branch.name), 1)
          ]),
          "cell-phone": _withCtx(({ row: branch }) => [
            _createTextVNode(_toDisplayString(branch.phone), 1)
          ]),
          "cell-address": _withCtx(({ row: branch }) => [
            _createTextVNode(_toDisplayString(branch.address), 1)
          ]),
          "cell-isOpen": _withCtx(({ row: branch }) => [
            _createElementVNode("span", {
              class: _normalizeClass([`badge-light-${branch.isOpen ? 'success' : 'danger'}`, "badge"])
            }, _toDisplayString(branch.isOpen
                ? _ctx.I18nUtils.translate("sea.pages.branches.badgeTextOpen")
                : _ctx.I18nUtils.translate("sea.pages.branches.badgeTextClosed")), 3)
          ]),
          "cell-isEnabled": _withCtx(({ row: branch }) => [
            _createElementVNode("span", {
              class: _normalizeClass([`badge-light-${branch.isEnabled ? 'success' : 'danger'}`, "badge"])
            }, _toDisplayString(branch.isEnabled
                ? _ctx.I18nUtils.translate("sea.pages.branches.badgeTextEnabled")
                : _ctx.I18nUtils.translate("sea.pages.branches.badgeTextDisabled")), 3)
          ]),
          "cell-date": _withCtx(({ row: branch }) => [
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(_ctx.DateTimeUtils.parseDateTime(branch.createdAt)) + " ", 1),
            (branch.modifiedAt)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_18,
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.DateTimeUtils.parseDateTime(branch.modifiedAt)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          "cell-actions": _withCtx(({ row: branch }) => [
            _createElementVNode("a", _hoisted_20, [
              _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.buttonActions")) + " ", 1),
              _createElementVNode("span", _hoisted_21, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_router_link, {
                  to: { name: 'branch', params: { id: branch.id } },
                  class: "menu-link px-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.buttonView")), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                (!branch.isOpen)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.openBranch(branch.id, branch.name)),
                      class: "menu-link px-3"
                    }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.buttonOpen")), 9, _hoisted_25))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.closeBranch(branch.id, branch.name)),
                      class: "menu-link px-3"
                    }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.buttonClose")), 9, _hoisted_26))
              ]),
              _createElementVNode("div", _hoisted_27, [
                (!branch.isEnabled)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.enableBranch(branch.id, branch.name)),
                      class: "menu-link px-3"
                    }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.buttonEnable")), 9, _hoisted_28))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.disableBranch(branch.id, branch.name)),
                      class: "menu-link px-3"
                    }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.buttonDisable")), 9, _hoisted_29))
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading", "table-headers", "data", "total", "page-number", "page-size", "onPageSizeChange", "onPageNumberChange", "onSort"])
      ])
    ]),
    _createVNode(_component_ConfirmationModal, {
      ref: "openBranchModal",
      "ok-button-style": 'btn-primary',
      onOkClick: _ctx.doOpenBranch
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalTitleOpenBranch")), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalBodyOpenBranch", {
          name: _ctx.modalBranchName,
        })), 1)
      ]),
      okButton: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalOkTextOpenBranch")), 1)
      ]),
      noButton: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalNoTextOpenBranch")), 1)
      ]),
      _: 1
    }, 8, ["onOkClick"]),
    _createVNode(_component_ConfirmationModal, {
      ref: "closeBranchModal",
      "ok-button-style": 'btn-warning',
      onOkClick: _ctx.doCloseBranch
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalTitleCloseBranch")), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalBodyCloseBranch", {
          name: _ctx.modalBranchName,
        })), 1)
      ]),
      okButton: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalOkTextCloseBranch")), 1)
      ]),
      noButton: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalNoTextCloseBranch")), 1)
      ]),
      _: 1
    }, 8, ["onOkClick"]),
    _createVNode(_component_ConfirmationModal, {
      ref: "enableBranchModal",
      "ok-button-style": 'btn-success',
      onOkClick: _ctx.doEnableBranch
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalTitleEnableBranch")), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalBodyEnableBranch", {
          name: _ctx.modalBranchName,
        })), 1)
      ]),
      okButton: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalOkTextEnableBranch")), 1)
      ]),
      noButton: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalNoTextEnableBranch")), 1)
      ]),
      _: 1
    }, 8, ["onOkClick"]),
    _createVNode(_component_ConfirmationModal, {
      ref: "disableBranchModal",
      "ok-button-style": 'btn-danger',
      onOkClick: _ctx.doDisableBranch
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalTitleDisableBranch")), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalBodyDisableBranch", {
          name: _ctx.modalBranchName,
        })), 1)
      ]),
      okButton: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalOkTextDisableBranch")), 1)
      ]),
      noButton: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.branches.modalNoTextDisableBranch")), 1)
      ]),
      _: 1
    }, 8, ["onOkClick"])
  ], 64))
}